import { footerStyles } from "@insite/content-library/Pages/Footer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

footerStyles.page = {
    fullWidth: [true, true, true, true, true],
    padding: 0,
    css: css`
        padding-top: 15px; // prevents image above from overlapping
        background: ${getColor("text.accent")}; // show gray all the way to edge
        margin-top: 6.5rem;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 0rem;
                `,
                css`
                    margin-top: 6.5rem;
                `,
                css`
                    margin-top: 6.5rem;
                `,
                css`
                    margin-top: 6.5rem;
                `,
                css`
                    margin-top: 6.5rem;
                `,
            ])}
    `,
};
